import { ReactComponent as TournamentTablesSvg } from "../../assets/images/svgs/tournamentTables.svg";

const TournamentTablesIcon = ({ className = "", ...props }) => {
  return (
    <TournamentTablesSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default TournamentTablesIcon;
